var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-panel-contenter"},[_c('private-border'),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-title clearfix"},[_vm._t("box-title")],2),_c('div',{staticClass:"box-inner"},[_vm._t("box-inner")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }